import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext, KioskImageOption } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

export class GetKioskImagesUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  // Images in the operator's kiosk images folder: Asset Manager title + file name, e.g. "banner_v1.png"
  async execute(ctx: KioskFlowOperatorContext): Promise<KioskImageOption[]> {
    assertOperator(ctx);
    return this.repository.getImages(ctx);
  }
}
